<template>
  <div class="h-screen grid place-items-center">
    <div>
      <h1>Что то пошло не так!</h1>
      <h3>Ресурс не найден.</h3>
      <router-link
        class="text-blue-500 underline hover:no-underline"
        to="/"
      >Вернитесь на главную страницу</router-link>
    </div>
  </div>
</template>

